<div class="main">
  <div class="header">
    <div class="ui container h-full">
      <div class="h-full flex items-center">
        <img [src]="logo ? logo : '../../../assets/images/logo-color.png'" alt="accountOn" class="logo" />
      </div>
    </div>
  </div>
  <div class="content">
    <div class="ui container h-full">
      <div class="h-full flex items-center">
        <div class="w-full text-center">
          <img src="../../../assets/images/icon-sign.svg" class="mx-auto mb-5" />
          <h1>
            {{ (isError ? "ok-sign-success.error" : "ok-sign-success.successMsg") | translate }}
          </h1>
          <p class="description">
            {{ (isError ? "ok-sign-success.errorDescription" : "ok-sign-success.successDescription") | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
